"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("underscore");
const core_1 = require("@angular/core");
const core_2 = require("@uirouter/core");
const organisation_service_1 = require("../services/organisation.service");
const devextreme_angular_1 = require("devextreme-angular");
require("../Models");
const i0 = require("@angular/core");
const i1 = require("@uirouter/core");
const i2 = require("../services/organisation.service");
const i3 = require("devextreme-angular");
const i4 = require("devextreme-angular/ui/nested");
const i5 = require("devextreme-angular/core");
const i6 = require("@angular/forms");
const i7 = require("@angular/common");
function DeviceActivationComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h3", 34);
    i0.ɵɵtext(2, "PRODA device activation");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function DeviceActivationComponent_option_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("value", item_r6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r6);
} }
function DeviceActivationComponent_ul_49_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul");
    i0.ɵɵelementStart(1, "li");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const serverValidationMessage_r7 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(serverValidationMessage_r7);
} }
const _c0 = function () { return ["deviceName", "prodaOrganisationId", "deviceActivationDate", "deviceExpiryDate", "keyExpiryDate", "status"]; };
if (!/localhost/.test(document.location.host)) {
    core_1.enableProdMode();
}
class DeviceActivationComponent {
    constructor($state, organisationService, notificationService) {
        this.$state = $state;
        this.organisationService = organisationService;
        this.notificationService = notificationService;
        this.activatedDevices = [];
        this.devicesDropdownList = [];
        this.prodaOrganisationId = "";
        this.deviceName = "";
        this.deviceActivationCode = "";
        this.prodaOrganisationIdValidator = new RegExp(/^[0-9]{9,11}$/);
        this.deviceNameValidator = new RegExp(/^[A-Za-z0-9_\.\-]+$/);
        this.deviceActivationCodeValidator = new RegExp(/^[A-Za-z0-9]{9,11}$/);
        this.prodaOrganisationIdIsReadOnly = true;
        this.prodaOrganisationIdValidationMessage = "";
        this.deviceNameValidationMessage = "";
        this.deviceActivationCodeValidationMessage = "";
        this.serverErrorMessage = "";
        this.serverValidationMessages = [];
        this.activateNewDevice = () => {
            this.popupVisible = true;
        };
        this.cancel = () => {
            this.popupVisible = false;
            this.resetDeviceActivationProperties();
            this.resetValidationMessages();
        };
        this.validateProdaOrganisationId = () => {
            let valid = this.prodaOrganisationIdValidator.test(this.prodaOrganisationId);
            this.prodaOrganisationIdValidationMessage = valid ? "" : "Please enter a valid PRODA organisation ID (RA number)";
            return valid;
        };
        this.validateDeviceName = () => {
            let valid = this.deviceNameValidator.test(this.deviceName);
            this.deviceNameValidationMessage = valid ? "" : "Please enter a valid PRODA device name";
            return valid;
        };
        this.validateDeviceActivationCode = () => {
            let valid = this.deviceActivationCodeValidator.test(this.deviceActivationCode);
            this.deviceActivationCodeValidationMessage = valid ? "" : "Please enter a valid device activation code";
            return valid;
        };
        this.saveNewDevice = () => {
            // Perform validation on all three fields. Only proceed if each field is valid.
            let valid = [this.validateProdaOrganisationId(), this.validateDeviceName(), this.validateDeviceActivationCode()];
            if (!valid.every(Boolean))
                return;
            // Send the device activation fields to the server.
            // Handle success and failure results.
            this.organisationService.activateProdaDevice(this.prodaOrganisationId, this.deviceName, this.deviceActivationCode)
                .then(() => {
                this.refreshActivatedProdaDevices();
                this.cancel();
            }, (error) => {
                if (!error.modelStateSummary) {
                    this.notificationService.error("Unexpected error while activating the PRODA device.");
                }
                else {
                    this.prodaOrganisationIdValidationMessage = (error.modelStateSummary.prodaOrganisationId) ? error.modelStateSummary.prodaOrganisationId : "";
                    this.deviceNameValidationMessage = (error.modelStateSummary.deviceName) ? error.modelStateSummary.deviceName : "";
                    this.deviceActivationCodeValidationMessage = (error.modelStateSummary.deviceActivationCode) ? error.modelStateSummary.deviceActivationCode : "";
                    this.serverErrorMessage = error.modelStateSummary.unspecified;
                    this.serverValidationMessages = (error.data.modelState.deviceActivationError) ? error.data.modelState.deviceActivationError : [];
                }
            });
        };
        this.refreshActivatedProdaDevices = () => {
            this.organisationService.getActivatedProdaDevices()
                .then((result) => {
                this.prodaOrganisationId = result.prodaOrganisationId;
                this.prodaOrganisationIdIsReadOnly = (this.prodaOrganisationIdValidator.test(result.prodaOrganisationId));
                this.activatedDevices = result.devices;
                this.devicesDropdownList = result.facilityRaNumbers;
            }, (error) => {
                this.notificationService.error("Unexpected error while getting the PRODA device list.");
            });
        };
        this.resetDeviceActivationProperties = () => {
            if (!this.prodaOrganisationIdIsReadOnly) {
                this.prodaOrganisationId = "";
            }
            this.deviceName = "";
            this.deviceActivationCode = "";
        };
        this.resetValidationMessages = () => {
            this.prodaOrganisationIdValidationMessage = "";
            this.deviceNameValidationMessage = "";
            this.deviceActivationCodeValidationMessage = "";
            this.serverErrorMessage = "";
            this.serverValidationMessages = [];
        };
    }
    ngOnInit() {
        this.refreshActivatedProdaDevices();
        this.popupVisible = false;
    }
    onCellPrepared(e) {
        if (e.column.dataField == "status") {
            if (e.displayValue == "Expired" || e.displayValue == "Disabled") {
                e.cellElement.classList.add("status-highlight");
            }
            if (e.data.statusReason) {
                e.cellElement.innerHTML = e.displayValue + " - " + e.data.statusReason;
            }
        }
    }
}
exports.DeviceActivationComponent = DeviceActivationComponent;
DeviceActivationComponent.ɵfac = function DeviceActivationComponent_Factory(t) { return new (t || DeviceActivationComponent)(i0.ɵɵdirectiveInject(i1.StateService), i0.ɵɵdirectiveInject(i2.OrganisationService), i0.ɵɵdirectiveInject('notification.service')); };
DeviceActivationComponent.ɵcmp = i0.ɵɵdefineComponent({ type: DeviceActivationComponent, selectors: [["device-activation"]], viewQuery: function DeviceActivationComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(devextreme_angular_1.DxDataGridComponent, true);
        i0.ɵɵviewQuery(devextreme_angular_1.DxPopupComponent, true);
    } if (rf & 2) {
        var _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dataGrid = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popup = _t.first);
    } }, decls: 55, vars: 33, consts: [["nav-publisher", "admin", 1, "device-activation"], [1, "page-header"], [1, "col-xs-9"], [1, "col-xs-3", "create-new-btn"], ["type", "button", 1, "btn", "btn-primary", "btn-lg", "pull-right", 3, "click"], [1, "col-xs-12"], ["id", "dataGrid", 3, "dataSource", "columns", "showBorders", "showColumnLines", "showRowLines", "cellHintEnabled", "allowColumnResizing", "columnAutoWidth", "noDataText", "onCellPrepared"], [3, "enabled"], ["dataField", "deviceName", "alignment", "left", "dataType", "string", "caption", "DEVICE NAME", 3, "allowSorting"], ["dataField", "prodaOrganisationId", "alignment", "left", "dataType", "string", "caption", "ORGANISATION ID (RA)", 3, "allowSorting"], ["dataField", "deviceActivationDate", "alignment", "left", "format", "dd MMM yyyy", "dataType", "date", "caption", "ACTIVATED", 3, "allowSorting"], ["dataField", "deviceExpiryDate", "alignment", "left", "format", "dd MMM yyyy", "dataType", "date", "caption", "DEVICE EXPIRY DATE", 3, "allowSorting"], ["dataField", "keyExpiryDate", "alignment", "left", "format", "dd MMM yyyy", "dataType", "date", "caption", "KEY EXPIRY DATE", 3, "allowSorting"], ["dataField", "status", "alignment", "left", "dataType", "string", "caption", "STATUS", 3, "allowSorting"], ["id", "popup", "width", "600", "height", "auto", "showTitle", "true", "dragEnabled", "false", "closeOnOutsideClick", "true", "showCloseButton", "true", "container", ".ng-scope", "titleTemplate", "title", 3, "visible", "visibleChange", "onHiding"], [4, "dxTemplate", "dxTemplateOf"], [1, "modal-body"], [1, "form-group"], ["for", "prodaOrganisationId", 1, "control-label"], ["name", "prodaOrganisationId", 1, "form-control", "input-lg", 3, "disabled", "ngModel", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], ["data-automation", "prodaOrganisationIdValidationMessage", 1, "validation-message", 3, "hidden"], ["for", "deviceName", 1, "control-label"], ["required", "", "type", "text", "name", "deviceName", "maxlength", "50", 1, "form-control", "input-lg", 3, "ngModel", "ngModelChange"], ["nameVar", "ngModel"], ["data-automation", "deviceNameValidationMessage", 1, "validation-message", 3, "hidden"], ["for", "deviceActivationCode", 1, "control-label"], ["required", "", "type", "text", "name", "deviceActivationCode", "maxlength", "10", 1, "form-control", "input-lg", 3, "ngModel", "ngModelChange"], ["data-automation", "deviceActivationCodeValidationMessage", 1, "validation-message", 3, "hidden"], [1, "server-validation-message", 3, "hidden"], [4, "ngFor", "ngForOf"], [1, "modal-footer"], ["type", "button", 1, "btn", "btn-warning", "btn-lg", "pull-left", 3, "click"], ["type", "button", "data-automation", "deviceActivationSave", 1, "btn", "btn-primary", "btn-lg", "pull-right", 3, "click"], [1, "modal-title"], [3, "value"]], template: function DeviceActivationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "h1");
        i0.ɵɵtext(4, "PRODA device registration");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "p");
        i0.ɵɵtext(6, "Activate your registered PRODA device");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 3);
        i0.ɵɵelementStart(8, "button", 4);
        i0.ɵɵlistener("click", function DeviceActivationComponent_Template_button_click_8_listener() { return ctx.activateNewDevice(); });
        i0.ɵɵtext(9, "Activate new");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 5);
        i0.ɵɵelementStart(11, "dx-data-grid", 6);
        i0.ɵɵlistener("onCellPrepared", function DeviceActivationComponent_Template_dx_data_grid_onCellPrepared_11_listener($event) { return ctx.onCellPrepared($event); });
        i0.ɵɵelement(12, "dxo-paging", 7);
        i0.ɵɵelement(13, "dxi-column", 8);
        i0.ɵɵelement(14, "dxi-column", 9);
        i0.ɵɵelement(15, "dxi-column", 10);
        i0.ɵɵelement(16, "dxi-column", 11);
        i0.ɵɵelement(17, "dxi-column", 12);
        i0.ɵɵelement(18, "dxi-column", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "div");
        i0.ɵɵelementStart(20, "dx-popup", 14);
        i0.ɵɵlistener("visibleChange", function DeviceActivationComponent_Template_dx_popup_visibleChange_20_listener($event) { return ctx.popupVisible = $event; })("onHiding", function DeviceActivationComponent_Template_dx_popup_onHiding_20_listener() { return ctx.cancel(); });
        i0.ɵɵtemplate(21, DeviceActivationComponent_div_21_Template, 3, 0, "div", 15);
        i0.ɵɵelementStart(22, "div", 16);
        i0.ɵɵelementStart(23, "form");
        i0.ɵɵelementStart(24, "div", 17);
        i0.ɵɵelementStart(25, "label", 18);
        i0.ɵɵtext(26, "PRODA organisation RA number");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "select", 19);
        i0.ɵɵlistener("ngModelChange", function DeviceActivationComponent_Template_select_ngModelChange_27_listener($event) { return ctx.prodaOrganisationId = $event; });
        i0.ɵɵtemplate(28, DeviceActivationComponent_option_28_Template, 2, 2, "option", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(29, "div", 21);
        i0.ɵɵtext(30);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "div", 17);
        i0.ɵɵelementStart(32, "label", 22);
        i0.ɵɵtext(33, "Device name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(34, "input", 23, 24);
        i0.ɵɵlistener("ngModelChange", function DeviceActivationComponent_Template_input_ngModelChange_34_listener($event) { return ctx.deviceName = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(36, "div", 25);
        i0.ɵɵtext(37);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(38, "div", 17);
        i0.ɵɵelementStart(39, "label", 26);
        i0.ɵɵtext(40, "Device activation code");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(41, "input", 27, 24);
        i0.ɵɵlistener("ngModelChange", function DeviceActivationComponent_Template_input_ngModelChange_41_listener($event) { return ctx.deviceActivationCode = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(43, "div", 28);
        i0.ɵɵtext(44);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(45, "div", 29);
        i0.ɵɵelementStart(46, "strong");
        i0.ɵɵtext(47);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(48, "br");
        i0.ɵɵtemplate(49, DeviceActivationComponent_ul_49_Template, 3, 1, "ul", 30);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(50, "div", 31);
        i0.ɵɵelementStart(51, "button", 32);
        i0.ɵɵlistener("click", function DeviceActivationComponent_Template_button_click_51_listener() { return ctx.cancel(); });
        i0.ɵɵtext(52, "Cancel");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(53, "button", 33);
        i0.ɵɵlistener("click", function DeviceActivationComponent_Template_button_click_53_listener() { return ctx.saveNewDevice(); });
        i0.ɵɵtext(54, "Save");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(11);
        i0.ɵɵproperty("dataSource", ctx.activatedDevices)("columns", i0.ɵɵpureFunction0(32, _c0))("showBorders", true)("showColumnLines", true)("showRowLines", true)("cellHintEnabled", true)("allowColumnResizing", true)("columnAutoWidth", true)("noDataText", "No devices");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("enabled", false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("allowSorting", false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("allowSorting", false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("allowSorting", false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("allowSorting", false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("allowSorting", false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("allowSorting", false);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("visible", ctx.popupVisible);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("dxTemplateOf", "title");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("disabled", ctx.devicesDropdownList.length < 2)("ngModel", ctx.prodaOrganisationId);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.devicesDropdownList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("hidden", ctx.prodaOrganisationIdValidationMessage == "");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.prodaOrganisationIdValidationMessage, " ");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngModel", ctx.deviceName);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("hidden", ctx.deviceNameValidationMessage == "");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.deviceNameValidationMessage, " ");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngModel", ctx.deviceActivationCode);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("hidden", ctx.deviceActivationCodeValidationMessage == "");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.deviceActivationCodeValidationMessage, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("hidden", ctx.serverValidationMessages.length == 0 && ctx.serverErrorMessage == "");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.serverErrorMessage);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.serverValidationMessages);
    } }, directives: [i3.DxDataGridComponent, i4.DxoPagingComponent, i4.DxiColumnComponent, i3.DxPopupComponent, i5.DxTemplateDirective, i6.ɵangular_packages_forms_forms_y, i6.NgControlStatusGroup, i6.NgForm, i6.SelectControlValueAccessor, i6.NgControlStatus, i6.NgModel, i7.NgForOf, i6.DefaultValueAccessor, i6.RequiredValidator, i6.MaxLengthValidator, i6.NgSelectOption, i6.ɵangular_packages_forms_forms_x], encapsulation: 2 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(DeviceActivationComponent, [{
        type: core_1.Component,
        args: [{
                selector: 'device-activation',
                templateUrl: './deviceActivation.component.html'
            }]
    }], function () { return [{ type: i1.StateService }, { type: i2.OrganisationService }, { type: undefined, decorators: [{
                type: core_1.Inject,
                args: ['notification.service']
            }] }]; }, { dataGrid: [{
            type: core_1.ViewChild,
            args: [devextreme_angular_1.DxDataGridComponent, { static: false }]
        }], popup: [{
            type: core_1.ViewChild,
            args: [devextreme_angular_1.DxPopupComponent, { static: false }]
        }] }); })();
